import { render } from "./ActiveMedicalCert.vue?vue&type=template&id=e70d272e&scoped=true"
import script from "./ActiveMedicalCert.vue?vue&type=script&lang=js"
export * from "./ActiveMedicalCert.vue?vue&type=script&lang=js"

import "./ActiveMedicalCert.vue?vue&type=style&index=0&id=e70d272e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e70d272e"]])

export default __exports__